<template>
	<div id='handimg-back' @click='handback'>
			
			<img :src="record" alt="">
			<!-- style='-webkit-user-select: none;margin: auto;cursor: zoom-in;background-color: hsl(0, 0%, 90%);transition: background-color 300ms;aspect-ratio: auto 261 / 565;' -->
	</div>
</template>

<script>
		import App from '@/assets/app.js';
	export default {
		props: ['ishand','record'],
		data() {
			return {
				imgurl:this.$api.getimg + '?aduitid='+this.record.aduitid+'&token='+this.$store.state.token +'&r='+ Date.parse(new Date())
			}
		},
		mounted(){
			// this.getdata()
			
		},
		methods: {
			getdata(){
				// this.$ajax({
				// 	methods:'get',
				// 	url:this.$api.getimg,
				// 	// params:{
				// 	// 	aduitid:this.record.aduitid,
				// 	// 	// token:this.$store.state.token
				// 	// }
				// }).then(res=>{
				// 	console.log(res.data)
					// this.imgurl = 
				// }).catch(err=>{
				// })
			},
			handback(){
				this.$emit('child',true)
			}
		}
	}
</script>

<style lang='scss' scoped>
	#handimg-back {
		position: fixed;
		width: 100vw;
		height: 100vh;
		left: 0vw;
		top: 0vh;
		background-color: rgba(0, 0, 0, 0.45);
		z-index: 99;
		padding: 3rem;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	#handimg-back img{
		    width: auto;
		    height: auto;
		    max-width: 100%;
		    max-height: 100%;  
	}
</style>